export const DEFAULT_AD_STREAM_URL = 'ad stream url'; // check VAST info
export const DEFAULT_AD_ASSET_NAME = 'ad name'; // check VAST info
export const DEFAULT_AD_SYSTEM = 'NA';
export const DEFAULT_AD_IS_SLATE = 'false';
export const DEFAULT_AD_MEDIA_FILE_API_FRAMEWORK = 'NA';
export const DEFAULT_AD_FIRST_AD_SYSTEM = 'NA';
export const DEFAULT_AD_STITCHER = 'NA';
export const DEFAULT_AD_ID = 'NA';
export const DEFAULT_AD_FIRST_CREATIVE_ID = 'NA';
export const DEFAULT_AD_CREATIVE_ID = 'NA';

export const getConnectionType = (): string => {
  const connectionType = (window as any)?.navigator?.connection?.effectiveType;
  if (!connectionType) {
    return 'wifi';
  }
  switch (connectionType) {
    case 'slow-2g':
      return 'OTHER';
    case '2g':
      return '2G';
    case '3g':
      return '3G';
    case '4g':
      return '4G';
    default:
      return 'OTHER';
  }
};
